import { Button, Box, TextField, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import '../App.css';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { MuiFileInput } from 'mui-file-input'
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SaveIcon from '@mui/icons-material/Save';
import { getDocumentPresignedAWS, uploadFileAWS, insertDocumentAWS } from '../offchain-logic/services';

interface props {
    setDocumentChange: React.Dispatch<React.SetStateAction<boolean>>;
    userAuthenticated: string;
    handleOpenToast: ((message: string, severity: 'success' | 'error') => void);
}

export const UploadDocs: React.FC<props> = ({ setDocumentChange, userAuthenticated, handleOpenToast }) => {

    const navigate = useNavigate();

    const [saved, setSaved] = useState<boolean>(false);
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [description, setDescription] = useState<string>("");
    const [document, setDocument] = useState<File | null>(null);

    const handleChange = async (newDocument: File | null) => {
        setDocument(newDocument);
        if(!newDocument) return;
    }

    const handleCancel = () => {
        setOpenDialog(false);
        setSaved(false);
        setDescription("");
        setDocument(null);
        navigate("/documents");
    }

    const handleSubmit = () => {
        setSaved(true);
        if(document === null || description === "")
          return;
        
        const selectedActivityId = sessionStorage.getItem('selectedActivityId');
        if (!selectedActivityId) {
          handleOpenToast("Seleziona un'attività prima di caricare un documento.", 'error');
          return;
        }

        // Step 1: Ottieni presigned URL per upload
        getDocumentPresignedAWS(document.name, document.type, selectedActivityId, null, null, (err: any, res: any) => {
          if(err !== null || res === null){
            handleOpenToast("Si è verificato un problema, riprova più tardi.", 'error');
            return;
          }

          // La risposta potrebbe essere res.data o direttamente res
          const responseData = res.data || res;
          const { presigned_url, id_document, path } = responseData;

          // Step 2: Upload file direttamente su S3
          uploadFileAWS(presigned_url, document, (err: any, res: any) => {
            if(err !== null) {
              handleOpenToast("Errore durante l'upload del file: " + err, 'error');
              return;
            }
            
            if(res && (res.status === 200 || res.ok)){
              // Step 3: Salva metadata in DynamoDB
              let obj = {
                "id_document": id_document,
                "name": document.name,
                "description": description,
                "id_activity": selectedActivityId,
                "path": path,
                "mime_type": document.type
              };
              insertDocumentAWS(obj, (err: any, res: any) => {
                if(err !== null || res === null){
                  handleOpenToast("Si è verificato un problema, riprova più tardi.", 'error');
                  return;
                }

                setDocumentChange(true);
                setOpenDialog(true);
              });
            } else {
              handleOpenToast("Si è verificato un problema, riprova più tardi.", 'error');
            }
          });
        });
    }

    return (<>
        {/* Titolo */}
        <div className='panel-title'>
            <h1>AGGIUNGI DOCUMENTO</h1>
            <Button variant="outlined" disableElevation 
                size="large" startIcon={<ArrowBackIosNewIcon />}
                onClick={ e => handleCancel() }
            >Indietro</Button>
        </div>
        <Box className='panel-content' component="form" autoComplete="off">
            <div>
                <MuiFileInput className="file-input-mui" variant="outlined" margin="normal" error={saved && document==null} placeholder='Seleziona il documento da aggiungere' value={document} onChange={handleChange} name="file-upload" />
                <TextField fullWidth variant="outlined" margin="normal" error={saved && description === ''} required={true} value={description} onChange={e => {setDescription(e.target.value)}} name="description" label="Descrizione" />
                {/* <div style={{display: 'inline-flex', margin: '8px 24px 16px', lineHeight: "60px"}}>{hash}</div> */}
            </div>
            <div className='bottom-btns'>
                <Button disableElevation size="large" variant="contained" endIcon={<SaveIcon/>} onClick={e=> handleSubmit()}>Salva</Button>
                <Button disableElevation size="large" variant="outlined" endIcon={<RestartAltIcon/>} onClick={e=> handleCancel()}>Svuota</Button>
            </div>
        </Box>

        <Dialog
            open={openDialog}
            onClose={handleCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>Carica Documento <CheckCircleOutlineIcon/>
                </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Il documento è stato caricato con successo
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCancel} autoFocus>
                OK
              </Button>
            </DialogActions>
        </Dialog>
    </>);
}